import React from 'react';
import { Box, CircularProgress, Tabs, Tab } from '@mui/material';
import { ObraBalancoTab } from './ObraBalancoTab';
import { ObraAnaliseTab } from './ObraAnaliseTab';
import { ObraLancamentosTab } from './ObraLancamentosTab';
import { ObraPagamentosSemComprovacaoTab } from './ObraPagamentosSemComprovacaoTab';
import RelatorioQuantitativoTab from '../RelatorioQuantitativoTab';
import ObraDocumentacaoTab from '../ObraDocumentacaoTab';
import { ObraOrcamentoTab } from './ObraOrcamentoTab';
import { ObraCronogramaTab } from './ObraCronogramaTab';
import { ObraContratosTab } from './ObraContratosTab';
import { ObraUsuariosTab } from './ObraUsuariosTab';

interface ObraTabsContentProps {
    activeTab: string;
    activeAnaliseSubTab?: string;
    setActiveAnaliseSubTab?: (tab: string) => void;
    obraId: number;
    balanco: any;
    obra: any;
    valoresCorrigidos: any;
    custos: any[];
    loadingCustos: boolean;
    drillDownLancamentos: any[];
    breadcrumbs: any[];
    selectedInfo: any;
    handleItemClick: (item: any) => void;
    handleBreadcrumbClick: (index: number) => void;
    openAttachments: (anexos: any[]) => void;
    lancamentosFilter: any;
    setLancamentosFilter: (filter: any) => void;
    openLancamentoEdit: (lancamento: any, initialStep?: number) => void;
    handleLancamentoDelete: (lancamento: any) => void;
    refreshLancamentosTrigger: number;
    setIsValoresCorrigidosModalOpen: (isOpen: boolean) => void;
}

export const ObraTabsContent: React.FC<ObraTabsContentProps> = ({
    activeTab,
    activeAnaliseSubTab = 'categoria',
    setActiveAnaliseSubTab,
    obraId,
    balanco,
    obra,
    valoresCorrigidos,
    custos,
    loadingCustos,
    drillDownLancamentos,
    breadcrumbs,
    selectedInfo,
    handleItemClick,
    handleBreadcrumbClick,
    openAttachments,
    lancamentosFilter,
    setLancamentosFilter,
    openLancamentoEdit,
    handleLancamentoDelete,
    refreshLancamentosTrigger,
    setIsValoresCorrigidosModalOpen
}) => {
    const isAnaliseTab = activeTab === 'analise';

    if (loadingCustos && isAnaliseTab) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            {activeTab === 'balanco' && (
                <ObraBalancoTab
                    balanco={balanco}
                    obra={obra}
                    valoresCorrigidos={valoresCorrigidos}
                    onOpenValoresCorrigidos={() => setIsValoresCorrigidosModalOpen(true)}
                />
            )}

            {activeTab === 'orcamento' && <ObraOrcamentoTab obraId={obraId} />}
            {activeTab === 'cronograma' && <ObraCronogramaTab obraId={obraId} />}
            {activeTab === 'contratos' && <ObraContratosTab obraId={obraId} />}

            {activeTab === 'analise' && (
                <Box>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                        <Tabs
                            value={activeAnaliseSubTab}
                            onChange={(_, newValue) => setActiveAnaliseSubTab && setActiveAnaliseSubTab(newValue)}
                            aria-label="sub-abas analise"
                            variant="fullWidth"
                        >
                            <Tab label="Por Categoria" value="categoria" />
                            <Tab label="Por Fase" value="fase" />
                            <Tab label="Por Fornecedor" value="fornecedor" />
                        </Tabs>
                    </Box>
                    <ObraAnaliseTab
                        title={activeAnaliseSubTab === 'categoria' ? 'Análise de Custos por Categoria' : (activeAnaliseSubTab === 'fornecedor' ? 'Análise de Custos por Fornecedor' : 'Análise de Custos por Fase da Obra')}
                        custos={selectedInfo ? [] : custos}
                        lancamentos={drillDownLancamentos}
                        breadcrumbs={breadcrumbs}
                        selectedInfo={selectedInfo}
                        onItemClick={handleItemClick}
                        onBreadcrumbClick={handleBreadcrumbClick}
                        onOpenAttachments={openAttachments}
                    />
                </Box>
            )}

            {activeTab === 'lancamentos' && (
                <ObraLancamentosTab
                    obraId={obraId}
                    filters={lancamentosFilter}
                    onFilterChange={setLancamentosFilter}
                    onEdit={openLancamentoEdit}
                    onDelete={handleLancamentoDelete}
                    refreshTrigger={refreshLancamentosTrigger}
                />
            )}
            {activeTab === 'pagamentos_sem_comprovacao' && (
                <ObraPagamentosSemComprovacaoTab
                    obraId={obraId}
                    onEdit={openLancamentoEdit}
                    onAttach={(lancamento) => openLancamentoEdit(lancamento, 2)}
                    onDelete={handleLancamentoDelete}
                    refreshTrigger={refreshLancamentosTrigger}
                />
            )}
            {activeTab === 'relatorio_quantitativo' && <RelatorioQuantitativoTab obraId={obraId} />}
            {activeTab === 'documentacao' && <ObraDocumentacaoTab obraId={obraId} />}
            {activeTab === 'usuarios' && <ObraUsuariosTab obraId={obraId} />}
        </>
    );
};
